export interface DefaultValues {
	name: string;
	phone: string;
	cnpj: string;
	city: string;
	state: string;
	neighborhood: string;
	modality: string;
	establishmentIndicationCode: string;
}

export const defaultValues: DefaultValues = {
	name: '',
	phone: '',
	cnpj: '',
	city: '',
	state: '',
	neighborhood: '',
	modality: '',
	establishmentIndicationCode: '',
};
